import { useState, useEffect } from 'react'
import {
  Checkbox,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material'

import Dialog from './Dialog'
import TableCellRuolo from './table/TableCellRuolo'
import TableCellSesso from './table/TableCellSesso'
import SortableTableHead from './SortableTableHead'
import {
  colours,
  titlesDistinta,
  TESSERATI_PLAYERS_INCOMPATIBILITIES,
} from '../settings/settings'

const MAX_PLAYERS = 14

const columns = [
  { label: '', sortable: false },
  { label: 'Cognome', sortable: true, sortingField: 'cognome' },
  { label: 'Nome', sortable: true, sortingField: 'nome' },
  { label: 'Sesso', sortable: false },
  { label: 'Data di nascita', sortable: false },
  { label: 'Tessera', sortable: false },
]

const DialogDistintaPlayers = ({
  open,
  handleClose,
  triggerFunction,
  distintaPlayers,
  tesseratiPlayers,
}) => {
  const [selectedPlayers, setSelectedPlayers] = useState()
  const [selectedIncompatibility, setSelectedIncompatibility] = useState()

  useEffect(() => {
    if (open) setSelectedPlayers(distintaPlayers)
  }, [open, distintaPlayers])

  const GridWarning = ({ text }) => (
    <Grid size={12}>
      <center>
        <b>
          <i>{text}</i>
        </b>
      </center>
    </Grid>
  )

  const GridCheckbox = ({ label, value }) => (
    <Grid size={{ xs: 12, md: 3 }}>
      <Checkbox
        color='default'
        checked={selectedIncompatibility === value}
        onChange={() => setSelectedIncompatibility(value)}
      />
      {label}
    </Grid>
  )

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={() => triggerFunction(selectedPlayers)}
      title={titlesDistinta.titlePlayers}
      textConfirm='Conferma'
      maxWidth='lg'
      stretchHeight
    >
      {(!tesseratiPlayers?.length && (
        <GridWarning text='Nessun tesserato disponibile.' />
      )) || (
        <Grid container spacing={2} sx={{ width: '100%' }}>
          {TESSERATI_PLAYERS_INCOMPATIBILITIES.map(({ key, label }) => (
            <GridCheckbox key={`inc-${key}`} label={label} value={key} />
          ))}
          <Grid size={12}>
            <TableContainer component={Paper}>
              <Table size='small'>
                <SortableTableHead
                  columns={columns}
                  tableName='tesseratiPlayers'
                />
                <TableBody>
                  {tesseratiPlayers
                    ?.filter(t => t.incompatibility === selectedIncompatibility)
                    ?.map((t, index) => {
                      const isSelected = selectedPlayers
                        ?.map(p => p.idTesserato)
                        ?.includes(t._id)

                      return (
                        <TableRow
                          key={index}
                          sx={{
                            backgroundColor: isSelected
                              ? colours.highlightGreen
                              : colours.white,
                          }}
                        >
                          <TableCell>
                            <Checkbox
                              id={`${t._id}-checkbox`}
                              color='success'
                              checked={!!isSelected}
                              onChange={() => {
                                if (
                                  !isSelected &&
                                  selectedPlayers?.length >= MAX_PLAYERS
                                )
                                  return

                                const pNew = {
                                  idTesserato: t._id,
                                  incompatibility: selectedIncompatibility,
                                }
                                setSelectedPlayers(
                                  isSelected
                                    ? selectedPlayers?.filter(
                                        p => p.idTesserato !== t._id,
                                      )
                                    : !selectedPlayers
                                      ? [pNew]
                                      : [...selectedPlayers, pNew],
                                )
                              }}
                            />
                          </TableCell>
                          <TableCell>{t?.cognome}</TableCell>
                          <TableCell>{t?.nome}</TableCell>
                          <TableCellSesso sesso={t?.sesso} />
                          <TableCell>{t?.dataNascita}</TableCell>
                          <TableCellRuolo ruolo={t?.ruolo} />
                        </TableRow>
                      )
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      )}
    </Dialog>
  )
}

export default DialogDistintaPlayers
